
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

type Props = {
    errorMessage: string
    errorContext?: string
}

const ErrorDisplay: React.FC<Props> = ({ errorMessage, errorContext }) => {
    const { logout } = useAuth();

    return (
        <div className="error-page">
            {errorContext ?? 'Error:'} {errorMessage ? errorMessage : 'Ett oväntat fel har inträffat. Vänligen försök igen senare.'}
            <button onClick={logout}>Logga ut och rensa data</button>
        </div>
    )
}

export default ErrorDisplay
